'use client'

import { useTranslations } from 'next-intl'
import { Link } from '@repo/web-ui/components/link'
import { AppRoutes } from '@repo/web-utils/app-routes'
import { IconArrowForward } from '@repo/design-system-cf/components/icons'
import { useClubhousesGetDetailsQuery } from '@web/gen/clubhouses'
import { MembersIcon } from '../../../assets/icons'

export function MembersBox({
  slug,
  initialTotalMember,
}: {
  slug: string
  initialTotalMember?: number
}) {
  const { data: membersTotal } = useClubhousesGetDetailsQuery(
    {
      input: {
        clubhouseSlug: slug,
      },
    },
    { select: data => data?.clubhousesGetDetails?.clubhouse?.membersTotal },
  )

  const t = useTranslations('pages.clubhouse')

  const membersTotalNumber = membersTotal || initialTotalMember

  return (
    <Link
      href={`${AppRoutes.CLUBHOUSE}${slug}/members`}
      className={
        'rounded-[12px] col-span-1 flex flex-row items-center justify-start gap-3 border border-[#1313151F] bg-cf-purple-50 shadow-[0px_2px_4px_0px_#0000001A] p-4 hover:shadow-none'
      }
    >
      <MembersIcon className="size-6 sm:size-14 text-[#8559F9] shrink-0" />
      <div className="flex justify-between items-center w-full">
        <div className="flex sm:flex-col gap-2 sm:gap-0 items-center sm:items-start">
          <p className="text-cf-grey-1000 text-[18px] font-bold leading-[26px] md:text-[29px] md:leading-[38px]">
            {membersTotalNumber}
          </p>
          <p className="text-14 font-medium text-cf-grey-800">{t('detailsbox.members')}</p>
        </div>
        <IconArrowForward className="size-[18px] text-cf-purple-900 sm:hidden" />
      </div>
    </Link>
  )
}
